import {Component, Injector} from "@angular/core";
import {SimCameraService, SimEnumExtendedService, NotificationService, SimTrainingRoomService, SimMaterialDialogService} from "@services";
import {VideoSourceConfigurationDialogComponent} from "../video-source-configuration-dialog/video-source-configuration-dialog.component";

@Component({
	selector: "sim-camera-configuration-dialog",
	templateUrl: "./camera-configuration-dialog.component.html",
	styleUrls: ["./camera-configuration-dialog.component.scss"],
	standalone: false,
})
export class CameraConfigurationDialogComponent extends VideoSourceConfigurationDialogComponent {
	constructor(
		_injector: Injector,
		_simCameraService: SimCameraService,
		_simEnumService: SimEnumExtendedService,
		_simTrainingRoomService: SimTrainingRoomService,
		_simNotificationService: NotificationService,
		_simMatDialogService: SimMaterialDialogService,
	) {
		super(_injector, _simCameraService, _simEnumService, _simTrainingRoomService, _simNotificationService, _simMatDialogService);
	}
}
